import { LoaderCircle } from 'lucide-react';

const Spinner = () => (
  <div className="absolute inset-0 grid place-items-center z-50">
    <LoaderCircle className="animate-spin" color="white" size={48} />
  </div>
);

export default Spinner;
